(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var tab = document.querySelector('[data-okna-tabela]');
    if (!tab || !tab.tBodies.length) { return; }
    var tbody = tab.tBodies[0];
    var tryb = 'oba', aktywna = 'n', malejaco = false;

    var przel = document.querySelector('[data-okna-przelacznik]'), hint = document.querySelector('[data-okna-hint]');
    if (przel) { przel.hidden = false; }
    if (hint) { hint.hidden = false; }

    function wartosc(tr, okno) {
        if (okno === 'n') { return Number(tr.getAttribute('data-n')); }
        var td = tr.querySelector('[data-okno="' + okno + '"]');
        if (!td) { return null; }
        var v = parseFloat(td.getAttribute(tryb === 'z' ? 'data-z' : 'data-hits'));
        return isNaN(v) ? null : v;
    }
    function sortuj(okno) {
        var wiersze = Array.prototype.slice.call(tbody.rows);
        wiersze.sort(function (a, b) {
            var va = wartosc(a, okno), vb = wartosc(b, okno);
            if (va === null && vb === null) { return 0; }
            if (va === null) { return 1; }
            if (vb === null) { return -1; }
            if (va === vb) { return Number(a.getAttribute('data-n')) - Number(b.getAttribute('data-n')); }
            return malejaco ? vb - va : va - vb;
        });
        wiersze.forEach(function (tr) { tbody.appendChild(tr); });
        tab.querySelectorAll('th[data-okna-sort]').forEach(function (th) {
            var ta = th.getAttribute('data-okna-sort') === okno;
            th.setAttribute('aria-sort', ta ? (malejaco ? 'descending' : 'ascending') : 'none');
        });
    }

    document.querySelectorAll('[data-okna-tryb]').forEach(function (b) {
        b.addEventListener('click', function () {
            tryb = b.getAttribute('data-okna-tryb');
            document.querySelectorAll('[data-okna-tryb]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            tab.querySelectorAll('[data-okna-hits]').forEach(function (el) { el.hidden = tryb === 'z'; });
            tab.querySelectorAll('[data-okna-z]').forEach(function (el) { el.hidden = tryb === 'hits'; });
            // zmiana metryki zmienia porzadek juz posortowanej kolumny
            if (aktywna !== 'n') { sortuj(aktywna); }
        });
    });

    tab.querySelectorAll('th[data-okna-sort]').forEach(function (th) {
        th.tabIndex = 0;
        th.setAttribute('role', 'button');
        th.classList.add('cursor-pointer');
        var klik = function () {
            var okno = th.getAttribute('data-okna-sort');
            if (okno === aktywna) { malejaco = !malejaco; } else { aktywna = okno; malejaco = okno !== 'n'; }
            sortuj(okno);
        };
        th.addEventListener('click', klik);
        th.addEventListener('keydown', function (e) { if (e.key === __pewniaki_inline_cfg[0] || e.key === ' ') { e.preventDefault(); klik(); } });
    });
})();
})();
